import './PrimaryButton.scss';
import React from 'react';
import { Button } from 'primereact/button'

/**
 * This is a wrapper around the bs btn, to add design effects etc
 */
function PrimaryButton({className, variant,...restProps}) {

  let customClasses = `${className}`

  if (variant === 'flat') {
    customClasses = `FlatBtn ${customClasses}`
  }
  if (variant === 'outline') {
    customClasses = `OutlineBtn ${customClasses}`
  }

  return (
    <Button className={`PrimaryBtn ${customClasses} text-center flex justify-content-center align-items-center`} {...restProps}>
        {restProps.children}
    </Button>
  );
}

export default PrimaryButton;
